<ng-container *ngIf="health.isHealthy() || isAtAdminPage(); else maintenance">
  <router-outlet></router-outlet>
  <app-toasts></app-toasts>
</ng-container>

<ng-template #maintenance>
  <app-maintenance></app-maintenance>
</ng-template>
